import { Trans, useTranslation } from "react-i18next";
import Section from "@/components/Section";
import teamCollaboration from "@/assets/team-collaboration.png";
import responsibleAI from "@/assets/responsible-ai.png";

const OurStory = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Section 1: Who We Are */}
      <Section
        title={
          <>
            {t("aboutStory.s1.titlePre")}{" "}
            <span className="text-gradient-brand">{t("aboutStory.s1.titleAccent")}</span>
          </>
        }
        titleAs="h1"
      >
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
            <p>{t("aboutStory.s1.p1")}</p>
            <p>{t("aboutStory.s1.p2")}</p>
          </div>

          <div className="relative">
            <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
            <img
              src={teamCollaboration}
              alt={t("aboutStory.s1.imageAlt")}
              className="relative w-full h-full object-cover rounded-2xl border border-border/60"
            />
          </div>
        </div>
      </Section>

      {/* Section 2: Our Approach */}
      <Section
        surface="alt"
        title={
          <>
            {t("aboutStory.s2.titlePre")}{" "}
            <span className="text-gradient-brand">{t("aboutStory.s2.titleAccent")}</span>
          </>
        }
      >
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative order-2 md:order-1">
            <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
            <img
              src={responsibleAI}
              alt={t("aboutStory.s2.imageAlt")}
              className="relative w-full h-full object-cover rounded-2xl border border-border/60"
            />
          </div>

          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed order-1 md:order-2">
            <p>{t("aboutStory.s2.p1")}</p>
            <p>
              <Trans
                i18nKey="aboutStory.s2.p2"
                components={[<span className="font-semibold text-foreground" />]}
              />
            </p>
            <p>{t("aboutStory.s2.p3")}</p>
          </div>
        </div>
      </Section>
    </>
  );
};

export default OurStory;
